import React, { useState } from "react";
import "../../../styles/payrole-system/payrole-processor.css";

const GenerateBankFile = () => {
  const [fileFormat, setFileFormat] = useState("");
  const [selectedBank, setSelectedBank] = useState("");

  const employees = [
    { name: "Arjun Singh", salary: "₹53,488.5" },
    { name: "Vikash Shah", salary: "₹32,413.5" },
    { name: "Priya Kumar", salary: "₹30,928.5" },
    { name: "Priya Yadav", salary: "₹14,050.5" },
    { name: "Arjun Agarwal", salary: "₹57,525" },
    { name: "Kavya Yadav", salary: "₹48,202" },
    { name: "Kavya Agarwal", salary: "₹20,354" },
    { name: "Meera Verma", salary: "₹17,973.5" },
    { name: "Pooja Gupta", salary: "₹40,190" },
    { name: "Arjun Patel", salary: "₹22,571.5" }
  ];

  const fileFormats = [
    { value: "", label: "Select File Format" },
    { value: "csv", label: "CSV" },
    { value: "xlsx", label: "Excel (XLSX)" },
    { value: "txt", label: "Text File" }
  ];

  const banks = [
    { value: "", label: "Select Bank" },
    { value: "hdfc", label: "HDFC Bank" },
    { value: "icici", label: "ICICI Bank" },
    { value: "sbi", label: "State Bank of India" },
    { value: "axis", label: "Axis Bank" },
    { value: "kotak", label: "Kotak Mahindra Bank" }
  ];

  const handleGenerateFile = () => {
    if (!fileFormat || !selectedBank) {
      alert("Please select both file format and bank");
      return;
    }
    console.log("Generating file:", { fileFormat, selectedBank, employees });
  };

  return (
    <div className="pp-bank-file-generator">
      {/* Header Section */}
      <div className="pp-bank-file-header">
        <h2 className="pp-bank-file-title">Generate Bank Transfer Files</h2>
      </div>

      {/* Form Section */}
      <div className="pp-bank-file-form-grid">
        <div className="pp-bank-file-form-group">
          <label className="pp-bank-file-label">File Format</label>
          <select
            className="pp-bank-file-select"
            value={fileFormat}
            onChange={(e) => setFileFormat(e.target.value)}
          >
            {fileFormats.map((format) => (
              <option key={format.value} value={format.value}>
                {format.label}
              </option>
            ))}
          </select>
        </div>

        <div className="pp-bank-file-form-group">
          <label className="pp-bank-file-label">Bank</label>
          <select
            className="pp-bank-file-select"
            value={selectedBank}
            onChange={(e) => setSelectedBank(e.target.value)}
          >
            {banks.map((bank) => (
              <option key={bank.value} value={bank.value}>
                {bank.label}
              </option>
            ))}
          </select>
        </div>

        <div className="pp-bank-file-form-group">
          <button
            className="pp-bank-file-generate-btn"
            onClick={handleGenerateFile}
            disabled={!fileFormat || !selectedBank}
          >
            <svg
              className="pp-bank-file-generate-icon"
              width="20"
              height="20"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            Generate File
          </button>
        </div>
      </div>

      {/* Employee Preview Section */}
      <div className="pp-bank-file-preview">
        <h3 className="pp-bank-file-preview-title">
          Employees to be included ({employees.length})
        </h3>
        <div className="pp-bank-file-employee-grid">
          {employees.map((employee, index) => (
            <div key={index} className="pp-bank-file-employee-item">
              <span className="pp-bank-file-employee-name">{employee.name}</span>
              <span className="pp-bank-file-employee-salary">{employee.salary}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default GenerateBankFile; 